import routerView from '@/views/layout/routerView'

export const inquiryRoute = [
  // {
  //   path: 'inquiry',
  //   name: '智能商机',
  //   icon: 'icon-xiansuo2',
  //   hidden: false,
  //   component: routerView,
  //   children:
  //   [
  //     {
  //       path: 'instantMusicVideoDish',
  //       name: '短视频评论',
  //       icon: 'icon-xiansuo2',
  //       hidden: false,
  //       component: () => import('@/views/inquiry/page/instantMusicVideoDish'),
  //       meta: {
  //         nextStart: true,
  //         breadcrumb: ['智能拓客', '智能商机', '短视频评论']
  //       }
  //     },
  //     {
  //       path: 'addCareForAccount',
  //       name: '添加关心账号',
  //       component: () => import('@/views/inquiry/page/addCareForAccount'),
  //       meta: {
  //         nextStart: true,
  //         breadcrumb: ['智能拓客', '智能商机', '短视频评论', '添加关心账号']
  //       },
  //       hidden: true,
  //       hide: true
  //     },
  //     {
  //       path: 'addAntistop',
  //       name: '添加关键词',
  //       component: () => import('@/views/inquiry/page/addAntistop'),
  //       meta: {
  //         nextStart: true,
  //         breadcrumb: ['智能拓客', '智能商机', '短视频评论', '添加关键词']
  //       },
  //       hidden: true,
  //       hide: true
  //     }
  //   ]
  // }
]
export default inquiryRoute
